/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Service_CoachingInputs */

const en_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

const es_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

const fr_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

const de_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

const ja_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーチング`)
};

const zh_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指导培训`)
};

const ar_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدريب وتوجيه`)
};

const id_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatihan`)
};

const it_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

const ru_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коучинг`)
};

const pt_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

const ko_listing_category_service_coaching = /** @type {(inputs: Listing_Category_Service_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코칭`)
};

/**
* | output |
* | --- |
* | "Coaching" |
*
* @param {Listing_Category_Service_CoachingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_service_coaching = /** @type {((inputs?: Listing_Category_Service_CoachingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Service_CoachingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_service_coaching(inputs)
	if (locale === "es") return es_listing_category_service_coaching(inputs)
	if (locale === "fr") return fr_listing_category_service_coaching(inputs)
	if (locale === "de") return de_listing_category_service_coaching(inputs)
	if (locale === "ja") return ja_listing_category_service_coaching(inputs)
	if (locale === "zh") return zh_listing_category_service_coaching(inputs)
	if (locale === "ar") return ar_listing_category_service_coaching(inputs)
	if (locale === "id") return id_listing_category_service_coaching(inputs)
	if (locale === "it") return it_listing_category_service_coaching(inputs)
	if (locale === "ru") return ru_listing_category_service_coaching(inputs)
	if (locale === "pt") return pt_listing_category_service_coaching(inputs)
	return ko_listing_category_service_coaching(inputs)
});